import {getGeneratedLocaleFormatted, getLanguage} from './localeUtils';

export default function loadLocaleData(locale) {
    const language = getLanguage(getGeneratedLocaleFormatted(locale));

    let intlLibPolyfills = [];
    let intlLangPolyfills = [];

    if (!Intl.PluralRules) {
        intlLibPolyfills.push(
            import(/* webpackChunkName: "locale-data" */ /* webpackMode: "lazy" */ '@formatjs/intl-pluralrules/polyfill')
        );
        intlLangPolyfills.push(
            import(/* webpackChunkName: "locale-data" */ /* webpackMode: "lazy" */ `@formatjs/intl-pluralrules/dist/locale-data/${language}`)
        );
    }

    if (!Intl.RelativeTimeFormat) {
        intlLibPolyfills.push(
            import(/* webpackChunkName: "locale-data" */ /* webpackMode: "lazy" */ '@formatjs/intl-relativetimeformat/polyfill')
        );
        intlLangPolyfills.push(
            import(/* webpackChunkName: "locale-data" */ /* webpackMode: "lazy" */ `@formatjs/intl-relativetimeformat/dist/locale-data/${language}`)
        );
    }

    if (intlLibPolyfills.length === 0 && intlLangPolyfills.length === 0) return Promise.resolve();
    return Promise.all(intlLibPolyfills).then(() => Promise.all(intlLangPolyfills));
}
